import { TaxClassMapperParameter, TaxClassFactory } from "@/v2/models/tax-classes.js";
import mapperMixin from "@/v2/mixins/mapper.js";
import httpMixin from "@/v2/mixins/http.js";

export default {
    mixins: [mapperMixin, httpMixin],
    computed: {
        taxClassesUrl: {
            get() {
                return window.bo.taxClassesUrl;
            },
        },
    },
    methods: {
        _taxClassMapper(taxClass) {
            return {
                id: taxClass.id,
                code: taxClass.code,
                name: taxClass.name,
                percentage: taxClass.percentage,
                created_at: taxClass.created_at ? new Date(taxClass.created_at) : null,
                updated_at: taxClass.updated_at ? new Date(taxClass.updated_at) : null,
                visible: taxClass.visible,
            };
        },

        parseTaxClass(taxClass) {
            return TaxClassFactory.construct(this.createMapperParameter(new TaxClassMapperParameter()), taxClass);
        },

        parseTaxClasss(taxClasss) {
            let parsedTaxClasss = [];

            taxClasss.forEach((taxClassData) => {
                const taxClass = this.parseTaxClass(taxClassData);
                parsedTaxClasss.push(taxClass);
            });

            return parsedTaxClasss;
        },

        getTaxClass(id, payload, success, failure) {
            return this.getData(
                this.taxClassesUrl + "/" + id,
                payload,
                (response) => {
                    success(this.parseTaxClass(response.data));
                },
                failure
            );
        },

        getTaxClasss(payload, success, failure) {
            return this.getData(
                this.taxClassesUrl,
                payload,
                (response) => {
                    success(this.parseTaxClasss(response.data.data), response.data.meta);
                },
                failure
            );
        },
    },
};
